import { useEffect, useState } from 'react';
import type { Chat } from '@/data/types';
import { useChats } from '@/data/store';
import { loadPeople, type Person } from '@/lib/people';
import { Avatar } from './Avatar';
import { SheetOption, useOverlay } from './Overlay';

// "Reassign to someone else": everyone with Sentinel access, not only operators (Gary, 15 Oct).
// On Peace of Sleep chats the POS team comes first. Sample data offers two sample people.

const SAMPLE: Person[] = [
  { id: 'sample-ctn', name: 'Cape Town North operator', posStaff: false },
  { id: 'sample-cts', name: 'Cape Town South operator', posStaff: false },
];

export function ReassignSheet({ chat }: { chat: Chat }) {
  const { live, reassign } = useChats();
  const { closeSheet } = useOverlay();
  const [people, setPeople] = useState<Person[] | null>(live ? null : SAMPLE);
  // Pick, then confirm (Gary, 23 Oct): a mis-tap never moves a chat.
  const [picked, setPicked] = useState<Person | null>(null);

  useEffect(() => {
    if (!live) return;
    let gone = false;
    void loadPeople().then((p) => { if (!gone) setPeople(p); });
    return () => { gone = true; };
  }, [live]);

  const list = (people ?? [])
    .filter((p) => p.id !== chat.ownerId)
    .sort((a, b) => (chat.brand === 'pos' ? Number(b.posStaff) - Number(a.posStaff) : 0));

  if (picked) {
    return (
      <>
        <h2 className="chats-sheet-title">Give this chat to {picked.name}?</h2>
        <button type="button" className="chats-btn" onClick={() => { closeSheet(); reassign(chat.id, { id: picked.id, name: picked.name }); }}>Confirm</button>
        <button type="button" className="chats-btn chats-btn--ghost" onClick={() => setPicked(null)}>Back</button>
      </>
    );
  }

  return (
    <>
      <h2 className="chats-sheet-title">Owner</h2>
      {people === null && <p className="chats-sheet-hint">Loading...</p>}
      {list.map((p) => (
        <SheetOption
          key={p.id}
          icon={<Avatar name={p.name} colour={p.name.length} small />}
          title={p.name}
          sub={p.posStaff ? 'Peace of Sleep team' : ''}
          onClick={() => setPicked(p)}
        />
      ))}
    </>
  );
}
